import React, { useState } from 'react'
import Login from './Login'
import { ToastContainer, toast } from 'react-toastify';

import "../CSS/loginPage.css"
import "../CSS/global.css"

// icons start 
import { IoEye, IoEyeOff, IoMailOutline, IoKeyOutline } from "react-icons/io5";
import axios from 'axios';
import { API } from './constant';
// icons end

const LoginPage = () => {

    const [viewPassword, setViewPassword] = useState(false)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [otp, setOtp] = useState("")
    const [step, setStep] = useState(1); // 1: Login, 2: OTP
    const [loading, setLoading] = useState(false);

    const handleViewPassword = () => {
        setViewPassword(!viewPassword)
    }


    const handleLogin = async () => {
        // if (!email || !password) {
        //     toast.error("Please fill in all fields");
        //     return;
        // }
        if (!email) {
            toast.error("Please fill in all fields");
            return;
        }

        setLoading(true);
        try {
            const data = {
                email,
                // password
            }
            const res = await axios.post(`${API}/login`, data);
            if (res.data.otpRequired) {
                toast.info(res.data.message);
                setStep(2);
            } else {
                // This shouldn't happen with new logic but handle for safety
                toast.success(res.data.message);
                localStorage.setItem("token", res.data.token);
                setTimeout(() => {
                    window.location.href = "/home"
                }, 2000);
            }
        } catch (err) {
            console.log(err)
            toast.error(err.response?.data?.message || "Login failed");
        } finally {
            setLoading(false);
        }
    }

    const handleVerifyOtp = async () => {
        if (!otp || otp.length !== 6) {
            toast.error("Please enter a valid 6-digit code");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(`${API}/login/verify-otp`, { email, otp });
            toast.success(res.data.message);
            localStorage.setItem("token", res.data.token);
            setTimeout(() => {
                window.location.href = "/home"
            }, 2000);
        } catch (err) {
            console.log(err)
            toast.error(err.response?.data?.message || "Verification failed");
        } finally {
            setLoading(false);
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            if (step === 1) handleLogin();
            else handleVerifyOtp();
        }
    }


    return (
        <div>
            <Login>
                <div className='DFJCCAIC login_main_container'>
                    <div className='login_container '>
                        <div className='login_container_left'>
                            <div className='login_container_left_bg DFJCCAIC padding10'>

                                <div className='text_and_fields_container '>
                                    <div className=' '>
                                        <div>
                                            <h2 className='h2 textCenter'>
                                                {step === 1 ? "Let's Catch Big Dreams!" : "Verify Your Identity"}
                                            </h2>
                                            <p className='smallText textGrey textCenter'>
                                                {step === 1
                                                    ? "Pursue your dreams passionately and strive to achieve your goals every day."
                                                    : `We've sent a 6-digit verification code to ${email}. Please enter it below to continue.`}
                                            </p>
                                        </div>
                                    </div>

                                    <div className=''>
                                        {step === 1 ? (
                                            <>
                                                <div className='marginT20 width100'>
                                                    <label className='smallTextBold '>Email</label>
                                                </div>
                                                <div className='DFJCCAIC bg-white border border-gray-200 rounded px-2'>
                                                    <IoMailOutline className="text-gray-400 mr-2" />
                                                    <input
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        onKeyDown={handleKeyPress}
                                                        className='smallText padding105 width100 border-none outline-none'
                                                        type="email"
                                                        placeholder='Input your email'
                                                    />
                                                </div>
                                                {/* <div className='marginT20 width100'>
                                                    <label className='smallTextBold' >Password</label>
                                                </div> */}
                                                {/* <div className='DFJCCAIC bg-white border border-gray-200 rounded px-2'>
                                                    <IoKeyOutline className="text-gray-400 mr-2" />
                                                    <input
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        onKeyDown={handleKeyPress}
                                                        className='smallText padding105 width100 border-none outline-none'
                                                        type={`${viewPassword ? "text" : "password"}`}
                                                        placeholder='Input your password'
                                                    />
                                                    <span>{viewPassword ? <IoEye onClick={handleViewPassword} className="cursor-pointer" /> : <IoEyeOff onClick={handleViewPassword} className="cursor-pointer" />}</span>
                                                </div> */}
                                            </>
                                        ) : (
                                            <>
                                                <div className='marginT20 width100'>
                                                    <label className='smallTextBold '>Verification Code</label>
                                                </div>
                                                <div className='DFJCCAIC bg-white border border-gray-200 rounded px-2'>
                                                    <input
                                                        value={otp}
                                                        onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                                        onKeyDown={handleKeyPress}
                                                        className='smallText padding105 width100 text-center tracking-[1em] font-bold text-xl outline-none border-none'
                                                        type="text"
                                                        placeholder='000000'
                                                        autoFocus
                                                    />
                                                </div>
                                                <div className="marginT10 textCenter">
                                                    <p className="text-xs text-gray-400">
                                                        Didn't receive code? <span className="text-blue-500 cursor-pointer font-bold" onClick={() => setStep(1)}>Go Back</span>
                                                    </p>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className='marginT30 width100'>
                                        <button
                                            onClick={step === 1 ? handleLogin : handleVerifyOtp}
                                            disabled={loading}
                                            className={`width100 loginButton textWhite padding105 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                        >
                                            {loading ? 'Processing...' : (step === 1 ? 'Sign In' : 'Verify & Login')}
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className='login_container_right'>
                            <div className='login_container_right_bg'>

                            </div>
                        </div>
                    </div>

                </div>
            </Login>
            <ToastContainer autoClose={2000} />
        </div>

    )
}

export default LoginPage
